"use strict";
exports.__esModule = true;
exports.dollarsToCents = exports.toFormattedDollars = exports.toDollars = exports.toCents = void 0;
var toCents = function (dollars) {
    return Math.round(100 * parseFloat(dollars.replace(/[$,]/g, '')));
};
exports.toCents = toCents;
var toDollars = function (cents) {
    if (cents === void 0) { cents = 0; }
    var dollar = (cents / 100).toFixed(2);
    return dollar.replace(/\d(?=(\d{3})+\.)/g, '$&,');
};
exports.toDollars = toDollars;
var toFormattedDollars = function (cents) {
    return "$".concat((0, exports.toDollars)(cents));
};
exports.toFormattedDollars = toFormattedDollars;
var dollarsToCents = function (amount) {
    return parseInt(amount.replace(/\D/g, ''), 10);
};
exports.dollarsToCents = dollarsToCents;
